import React, { useState } from 'react';
import { loginUser } from '../utils/api';

function Login({ onLogin, onUsernameSet }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const data = await loginUser(password);      console.log('Результат логіну:', data);
      if (data.fullName) {
        // Зберігаємо ім'я користувача в localStorage
        localStorage.setItem('username', data.fullName);

        // Викликаємо передані функції
        if (onUsernameSet) {
          onUsernameSet(data.fullName);
        }
        if (onLogin) {
          onLogin(true);
        }

        setPassword('');
      } else {        setError(data.error || 'Помилка авторизації');
      }
    } catch (error) {
      console.error('Помилка при авторизації:', error);
      setError('Помилка підключення до сервера');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f0f0',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: '#fff',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          minWidth: '320px',
        }}
      >
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔐</div>          <h2 style={{ margin: 0, color: '#333', fontSize: '24px' }}>
            Авторизація
          </h2>
          <p
            style={{
              margin: '8px 0 0 0',
              color: '#666',
              fontSize: '14px',
            }}
          >
            Введіть пароль для доступу до системи
          </p>
        </div>

        {error && (
          <div
            style={{
              backgroundColor: '#ffebee',
              color: '#d32f2f',
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '16px',
              border: '1px solid #f44336',
              fontSize: '14px',
            }}
          >
            {error}
          </div>
        )}        <input
          type="password"
          placeholder="Введіть пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            border: '2px solid #e0e0e0',
            borderRadius: '6px',
            outline: 'none',
            marginBottom: '20px',
            transition: 'border-color 0.2s',
            boxSizing: 'border-box',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#2196f3';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
          }}
          autoFocus
        />

        <button
          type="submit"
          disabled={!password.trim()}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            fontWeight: '600',
            color: '#fff',
            backgroundColor: !password.trim() ? '#9e9e9e' : '#2196f3',
            border: 'none',
            borderRadius: '6px',
            cursor: !password.trim() ? 'not-allowed' : 'pointer',            transition: 'background-color 0.2s',
          }}
        >
          Увійти
        </button>
      </form>
    </div>
  );
}

export default Login;
